document.addEventListener("DOMContentLoaded",function(){
  const component = document.querySelector('.dropdown');

  if ( component ){
    const trigger = component.querySelector('.dropdown-trigger');
    trigger.addEventListener('click', () => component.classList.toggle('--active'));
  }
});
